import React from "react";

/**
 * Heatmap or table ("Wellness Block"). The design's horizontal-bar variant is
 * never rendered, so it is not built.
 *
 * @param {Object} props
 * @param {{ type: 'heat', cols: string[], corner?: string, rows: Array<Object>, foot?: string }
 *   | { type: 'table', colsCss: string, head: string[], rows: Array<{ key: string, bg: string, cells: Array<Object> }>, foot?: string }} props.block
 */
const WellnessBlock = ({ block: b }) => (
  <div className="flex flex-col gap-[12px] min-w-0">
    {b.type === "heat" && (
      <div className="overflow-x-auto">
        <div
          className="grid gap-[3px] min-w-0"
          style={{ gridTemplateColumns: `150px repeat(${(b.cols || []).length || 1},minmax(44px,1fr))` }}
        >
          <div className="text-[10px] font-bold tracking-[.06em] text-[#A39A93] py-[4px]">{b.corner}</div>
          {b.cols.map((c) => (
            <div key={c} className="text-[10px] font-bold text-[#6b6b6b] text-center py-[4px] leading-[1.3]">
              {c}
            </div>
          ))}
          {b.rows.map((r) => (
            <React.Fragment key={r.name}>
              <div
                className="text-[12px] flex items-center pr-[8px] whitespace-nowrap overflow-hidden text-ellipsis"
                style={{ fontWeight: r.weight }}
              >
                {r.name}
              </div>
              {r.cells.map((x, i) => (
                <div
                  key={i}
                  title={x.tip}
                  className="h-[30px] rounded-[4px] flex items-center justify-center text-[11px] font-semibold tabular-nums"
                  style={{ background: x.bg, boxShadow: x.ring, color: x.fg }}
                >
                  {x.txt}
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    )}

    {b.type === "table" && (
      <div className="flex flex-col min-w-0">
        <div className="grid gap-[12px] px-[10px] pb-[8px] border-b border-[#F1ECE8]" style={{ gridTemplateColumns: b.colsCss }}>
          {b.head.map((h) => (
            <span key={h} className="text-[10px] font-bold tracking-[.06em] text-[#A39A93]">
              {h}
            </span>
          ))}
        </div>
        {b.rows.map((r) => (
          <div
            key={r.key}
            className="grid gap-[12px] items-center px-[10px] py-[9px] border-b border-[#F7F3F0] text-[13px]"
            style={{ gridTemplateColumns: b.colsCss, background: r.bg }}
          >
            {r.cells.map((c, i) => (
              <span key={i} className="flex items-center gap-[8px] min-w-0 tabular-nums" style={{ color: c.fg, fontWeight: c.weight }}>
                {c.txt}
                {c.tag && (
                  <span className="text-[10px] font-bold rounded-[10px] px-[7px] py-[1px]" style={{ background: c.tagBg, color: c.tagFg }}>
                    {c.tag}
                  </span>
                )}
              </span>
            ))}
          </div>
        ))}
      </div>
    )}

    {b.foot && <span className="text-[11px] text-[#8a8a8a] leading-[1.5]">{b.foot}</span>}
  </div>
);

export default WellnessBlock;
